var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8Pos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.52 32.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".black{fill:#2f2e2b;}.yellow{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M12.76,32.46,12.28,32C9.35,29,3,21.68,1.35,18.45a12.76,12.76,0,1,1,24.17-5.7,12.81,12.81,0,0,1-1.35,5.7c-1.62,3.24-8,10.6-10.93,13.53Zm0-31.09A11.39,11.39,0,0,0,2.57,17.84C4,20.73,9.77,27.43,12.76,30.52c3-3.09,8.73-9.78,10.19-12.68A11.38,11.38,0,0,0,12.76,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M12.76,19.8h0a7.07,7.07,0,1,1,7.08-7.07h0a7.08,7.08,0,0,1-7.08,7.07ZM12.76,7a5.71,5.71,0,0,0,0,11.41h0A5.71,5.71,0,1,0,12.76,7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8Pos);
export default __webpack_public_path__ + "static/media/8-pos.6384bd62.svg";
export { ForwardRef as ReactComponent };